import { ConversationInsightsFiltersV1Schema } from "@redotech/redo-model/conversation-filters/conversation-insights-filters";
import { DateGroupingField } from "@redotech/redo-model/conversation-insights";
import { ConversationInsightsAnalyticsData } from "@redotech/redo-model/support/conversation-insights-analytics";
import * as z from "zod/v4";

export const getConversationInsightsAnalytics = {
  name: "getConversationInsightsAnalytics" as const,
  input: z.object({
    filters: ConversationInsightsFiltersV1Schema.optional(),
    dateGroupingField: DateGroupingField.optional(),
  }),
  output: ConversationInsightsAnalyticsData,
};
